export default __webpack_public_path__ + "static/media/Tereza Gontijo_.49d4828a.png";